import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getCustomerDataByWorkspaceSlug, getCustomerRequestByWorkspaceSlug } from 'selectors'
import CustomersProfileOverview from '../components/Customers/CustomersProfileOverview'

class CustomersProfileAppOverview extends Component {
  render () {
    return React.createElement(CustomersProfileOverview, this.props)
  }
}

function mapStateToProps (state, ownProps) {
  const { workspaceSlug } = ownProps.params

  const customer = getCustomerDataByWorkspaceSlug(state, workspaceSlug)
  const { isRequesting, didRequestFail } = getCustomerRequestByWorkspaceSlug(state, workspaceSlug)

  return {
    isRequesting,
    didRequestFail,
    user: customer,
    workspaceSlug
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomersProfileAppOverview)



// WEBPACK FOOTER //
// ./containers/CustomersProfileAppOverview.js